import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "lc_remarks_box"
};
const _hoisted_2 = {
  class: "lc_remarks_box_title"
};
const _hoisted_3 = {
  class: "lc_remarks_context"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("span", null, null, -1)), _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
    onInput: _ctx.changeInput,
    modelValue: _ctx.data.iptVal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.data.iptVal = $event),
    maxlength: "500",
    placeholder: "请输入",
    "show-word-limit": "",
    type: "textarea",
    resize: "none",
    autosize: {
      minRows: 11,
      maxRows: 11
    }
  }, null, 8, ["onInput", "modelValue"])])]);
}